/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Navigator from './navigator';

function App() {
  return <Navigator />;
}
export default App;
